import { isSameApplicationFlowMeta } from '../../utils/applicationDraft';
import {
  QUICK_CASH_DRAFT_KEY,
  QUICK_CASH_DRAFT_SCHEMA_VERSION,
  QUICK_CASH_PRODUCT_CODE,
} from './config';

export const QUICK_CASH_PENDING_PHONE_KEY = 'quick_cash_20000_pending_phone';
const QUICK_CASH_PENDING_ATTRIBUTION_KEY = 'quick_cash_20000_pending_attribution';

// session_id가 없는 직접 진입도 기존 신청과 섞이지 않도록 신규 추적값을 만든다.
const createPendingSessionId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `quick-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const readRawQuickCashDraft = () => {
  try {
    const serializedDraft = sessionStorage.getItem(QUICK_CASH_DRAFT_KEY);
    if (!serializedDraft) {
      return null;
    }

    const draft = JSON.parse(serializedDraft);
    // 다른 상품 데이터나 지원하지 않는 스키마는 Quick Cash 저장소에서만 제거한다.
    if (
      draft?.productCode !== QUICK_CASH_PRODUCT_CODE
      || draft?.schemaVersion !== QUICK_CASH_DRAFT_SCHEMA_VERSION
    ) {
      sessionStorage.removeItem(QUICK_CASH_DRAFT_KEY);
      return null;
    }
    return draft;
  } catch (error) {
    sessionStorage.removeItem(QUICK_CASH_DRAFT_KEY);
    return null;
  }
};

export const getQuickCashDraft = (expectedMeta) => {
  const draft = readRawQuickCashDraft();
  if (!draft) {
    return null;
  }
  if (expectedMeta && !isSameApplicationFlowMeta(draft.meta, expectedMeta)) {
    clearQuickCashDraft();
    return null;
  }
  return draft;
};

export const saveQuickCashDraft = ({ meta, currentStep, form1, form21, form22, uiState }) => {
  const existingDraft = meta ? getQuickCashDraft(meta) : readRawQuickCashDraft();
  const nextDraft = {
    ...(existingDraft ?? {}),
    productCode: QUICK_CASH_PRODUCT_CODE,
    schemaVersion: QUICK_CASH_DRAFT_SCHEMA_VERSION,
    updatedAt: new Date().toISOString(),
  };

  if (meta) nextDraft.meta = meta;
  if (currentStep) nextDraft.currentStep = currentStep;
  if (form1 !== undefined) nextDraft.form1 = form1;
  if (form21 !== undefined) nextDraft.form21 = form21;
  if (form22 !== undefined) nextDraft.form22 = form22;
  if (uiState !== undefined) nextDraft.uiState = uiState;

  if (!nextDraft.meta?.phone) {
    return null;
  }

  sessionStorage.setItem(QUICK_CASH_DRAFT_KEY, JSON.stringify(nextDraft));
  return nextDraft;
};

export const clearQuickCashDraft = () => {
  sessionStorage.removeItem(QUICK_CASH_DRAFT_KEY);
};

export const saveQuickCashPendingPhone = (phone) => {
  if (phone) {
    sessionStorage.setItem(QUICK_CASH_PENDING_PHONE_KEY, phone);
  }
};

export const getQuickCashPendingPhone = () => sessionStorage.getItem(QUICK_CASH_PENDING_PHONE_KEY) || '';

export const clearQuickCashPendingPhone = () => {
  sessionStorage.removeItem(QUICK_CASH_PENDING_PHONE_KEY);
};

export const saveQuickCashPendingAttribution = (search) => {
  // URL 진입만으로 기존 register의 session_id를 바꾸지 않고 임시 영역에 보관한다.
  const params = new URLSearchParams(search);
  const attribution = {
    session_id: params.get('session_id') || createPendingSessionId(),
    utm_medium: params.get('utm_medium') || '',
    utm_source: params.get('utm_source') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_id: params.get('utm_id') || '',
    utm_term: params.get('utm_term') || '',
    utm_content: params.get('utm_content') || '',
  };
  sessionStorage.setItem(QUICK_CASH_PENDING_ATTRIBUTION_KEY, JSON.stringify(attribution));
  return attribution;
};

export const getQuickCashPendingAttribution = () => {
  try {
    return JSON.parse(sessionStorage.getItem(QUICK_CASH_PENDING_ATTRIBUTION_KEY)) || {};
  } catch (error) {
    sessionStorage.removeItem(QUICK_CASH_PENDING_ATTRIBUTION_KEY);
    return {};
  }
};

export const commitQuickCashPendingAttribution = () => {
  // Quick Cash OTP 성공 후에만 대기 중인 session_id와 UTM을 활성 추적값으로 전환한다.
  const attribution = getQuickCashPendingAttribution();
  if (attribution.session_id) {
    localStorage.setItem('session_id', attribution.session_id);
  }
  ['utm_medium', 'utm_source', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'].forEach((key) => {
    if (attribution[key]) {
      sessionStorage.setItem(key, attribution[key]);
    }
  });
  sessionStorage.removeItem(QUICK_CASH_PENDING_ATTRIBUTION_KEY);
};

export const clearQuickCashPendingAttribution = () => {
  sessionStorage.removeItem(QUICK_CASH_PENDING_ATTRIBUTION_KEY);
};
